// Typelizer digest 40d68495a7eb7ca50a4ec3dc2efb45cf
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /learners/students/:student_id/workspace */
  show: (
    params: { studentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/students/:student_id/workspace', params, options),
    method: 'get',
  }),
}
